import React, { useEffect, useState } from "react";
import { smallImage } from "../lib/images";

// A person's photo (uploaded or from Google) with an initial-letter fallback.
export function UserAvatar({ name, avatar, size = 36, bg = "linear-gradient(135deg,#2F6BFF,#7C3AED)", className = "", testid }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [avatar]);
  const style = { width: size, height: size };
  const src = size <= 96 ? smallImage(avatar) : avatar;
  if (avatar && !broken) {
    return <img src={src} alt={name || ""} loading="lazy" decoding="async" referrerPolicy="no-referrer" onError={() => setBroken(true)} className={`shrink-0 rounded-full object-cover ${className}`} style={style} data-testid={testid} />;
  }
  return (
    <span className={`flex shrink-0 items-center justify-center rounded-full font-bold text-white ${className}`} style={{ ...style, fontSize: size * 0.4, background: bg }} data-testid={testid}>
      {(name || "?")[0].toUpperCase()}
    </span>
  );
}
